var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAskForModification(_vm.account, _vm.schoolList))?_c('BaseFlow',{attrs:{"icon":"fas fa-undo-alt","skip-confirm":true},on:{"click":_vm.sendMail}},[_vm._v(" Répondre à Coop Zone ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }